import { render, staticRenderFns } from "./op2.vue?vue&type=template&id=685b8b6d&scoped=true&"
import script from "./op2.vue?vue&type=script&lang=js&"
export * from "./op2.vue?vue&type=script&lang=js&"
import style0 from "./op2.vue?vue&type=style&index=0&id=685b8b6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685b8b6d",
  null
  
)

export default component.exports